import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { TextField, DatePicker, SelectField } from 'redux-form-material-ui';
import { deepDiver } from 'helpers/utilities';

import validate from 'components/landlord_app/components/validate';

import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import * as validator from 'helpers/Validator';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import * as format from 'helpers/Formatter';

import moment from 'moment';

let LeadDetailsForm = props => {
  const { handleSubmit, submitting, labelText, disabled, unitTypes, minimumApplicantAge } = props;
  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-sm-6">
          <Field
            name="first_name"
            component={TextField}
            floatingLabelText="First Name"
            multiLine={false}
            fullWidth
            validate={[validator.required]}
            style={{ marginTop: '-15px', fontSize: '15px' }}
          />
        </div>

        <div className="col-sm-6">
          <Field
            name="last_name"
            component={TextField}
            floatingLabelText="Last Name"
            multiLine={false}
            fullWidth
            validate={[validator.required]}
            style={{ marginTop: '-15px', fontSize: '15px' }}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <Field
            name="email"
            type="email"
            component={TextField}
            floatingLabelText="Email"
            multiLine={false}
            fullWidth
            validate={[validator.required, validator.validEmail]}
            style={{ marginTop: '-15px', fontSize: '15px' }}
          />
        </div>

        <div className="col-sm-6">
          <Field
            name="phone_number"
            component={TextField}
            floatingLabelText="Phone Number"
            multiLine={false}
            fullWidth
            normalize={validator.normalizePhone}
            validate={[validator.required, validator.phoneLength]}
            style={{ marginTop: '-15px', fontSize: '15px' }}
          />
        </div>
      </div>

      <div className="row" style={{ textAlign: 'initial' }}>
        <div className="col-sm-6">
          <Field
            name="desired_unit"
            component={SelectField}
            floatingLabelText="Desired Unit"
            validate={[validator.required]}
            style={{
              marginTop: '-15px',
              fontSize: '14px',
              width: '100%',
            }}
            disabled={disabled}
          >
            {unitTypes.map(unitType => (
              <MenuItem value={unitType.value} primaryText={unitType.label} />
            ))}
          </Field>
        </div>

        <div className="col-sm-6">
          <Field
            name="move_in_date"
            minDate={new Date()}
            component={DatePicker}
            formatDate={format.reformatDate}
            autoOk={true}
            textFieldStyle={{ width: '100%', fontSize: '14px' }}
            floatingLabelText="Desired Move In Date"
            validate={[validator.required]}
            disableYearSelection={true}
            style={{
              marginTop: '-15px',
            }}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <Field
            name="max_budget"
            component={TextField}
            floatingLabelText="Max Budget"
            multiLine={false}
            fullWidth
            validate={[validator.required, validator.greaterThanZero]}
            style={{ marginTop: '-15px', fontSize: '14px' }}
            {...format.currencyMask}
          />
        </div>
        <div className="col-sm-6">
          <Field
            name="dob"
            maxDate={moment()
              .subtract(minimumApplicantAge || 18, 'years')
              .toDate()}
            openToYearSelection={true}
            component={DatePicker}
            formatDate={format.reformatDate}
            autoOk={true}
            textFieldStyle={{ width: '100%', fontSize: '14px' }}
            floatingLabelText="Вirthday"
            disableYearSelection={false}
            style={{
              marginTop: '-15px',
            }}
          />
        </div>
      </div>

      <div className="row" style={{ textAlign: 'center', marginTop: '10px' }}>
        <FlatButton
          label={labelText || 'Book'}
          type="submit"
          primary={true}
          backgroundColor={submitting ? colors.LIGHT_GRAY : AccentColor()}
          disabled={submitting}
          hoverColor="grey"
          style={{
            color: submitting ? AccentColor() : 'white',
            height: '40px',
            margin: 'auto',
          }}
        />
      </div>
    </form>
  );
};

export default compose(
  connect(state => {
    let unitTypes = state.landlordProperties.unitTypes;
    if (unitTypes.length === 0) {
      unitTypes = state.landlordUsers.unitTypes;
    }
    return {
      unitTypes: unitTypes,
      minimumApplicantAge: state.companyDetails.companyPreferences.minimum_applicant_age,
      initialValues: {
        desired_unit: deepDiver(state, 'form.book_showing.values.unit_type'),
      },
    };
  }),
  reduxForm({
    form: 'lead_details_form',
    forceUnregisterOnUnmount: true,
    validate,
  })
)(LeadDetailsForm);
